(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('TrackNotificationService', TrackNotificationService);

  TrackNotificationService.$inject = ['$resource'];

  function TrackNotificationService ($resource) {
    return $resource(apiUrl + '/track-notification/:id', { id: '@id' }, {
      getTrackData: { url: apiUrl + '/track-notification/get-data', method: 'POST', params: {}, isArray: false },
      getTrackNotification: { url: apiUrl + '/track-notification/get-track-notification', method: 'POST', params: {}, isArray: false },
      registerDelivery: { url: apiUrl + '/track-notification/register-delivery', method: 'POST', params: {}, isArray: false },
      saveContract: { url: apiUrl + '/track-notification/save-contract/:contact_id/:contract', method: 'POST', params: {}, isArray: false }
    });
  }
})();
